import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import { jobInfoType } from '../../../common/interfaces/myProfile/personalDetails/jobInfo';
// Define a type for the slice state

// Define the initial state using that type

const initialState: jobInfoType = {
  staffId: 0,
  hireDate: new Date(),
  departmentName: '',
  employeeType: '',
  contractType: '',
  employeeCategory: '',
  payrollType: '',
  contractTypeId: 0,
  employeeCategoryId: 0,
  employeeTypeId: 0,
  payrollTypeId: 0,
  departmentId: 0,
  extNo: '',
};

const jobInfoSlice = createSlice({
  name: 'jobInformation',

  initialState,
  reducers: {
    jobInfoReducer: (
      state: jobInfoType,
      action: PayloadAction<jobInfoType>,
    ) => {
      const payload = action.payload;
      state.contractType = payload.contractType;
      state.departmentName = payload.departmentName;
      state.departmentId = payload.departmentId;
      state.employeeCategory = payload.employeeCategory;
      state.employeeType = payload.employeeType;
      state.hireDate = payload.hireDate;
      state.staffId = payload.staffId;
      state.payrollType = payload.payrollType;
      state.payrollTypeId = payload.payrollTypeId;
      state.employeeCategoryId = payload.employeeCategoryId;
      state.contractTypeId = payload.contractTypeId;
      state.employeeTypeId = payload.employeeTypeId;
      state.extNo = payload.extNo;
      state.isDirectManager = payload.isDirectManager;
      state.isDirectManagerStffId = payload.isDirectManagerStffId;
      state.grade = payload.grade;
    },
    resetJobInfo: (state: jobInfoType) => {
      state.contractType = '';
      state.departmentName = '';
      state.employeeCategory = '';
      state.employeeType = '';
      state.hireDate = new Date();
      state.staffId = 0;
      state.extNo = '';
      state.payrollType = '';
      state.isDirectManager = '';
      state.isDirectManagerStffId = '';
      state.grade = '';
    },
  },
});

export const { jobInfoReducer, resetJobInfo } = jobInfoSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default jobInfoSlice.reducer;
